/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AdditionalFieldInfo_formField$ref = any;
export type ApplicationType = "MAIN_APP" | "OPERATOR_PORTAL";
export type FormFieldType = "CHECKBOX" | "DATE" | "MULTILINE_TEXT" | "MULTISELECT" | "NUMBER" | "SELECT" | "SELECT_CUSTOMER" | "SELECT_MACHINE" | "SELECT_ORDER" | "SELECT_USER" | "TEXT";
export type FormType = "ITEM" | "JOB_STEP" | "JOB_TASK" | "JOB_YIELD";
export type JobStateStatus = "COMPLETE" | "INCOMPLETE" | "IN_PROGRESS" | "NEEDS_ATTENTION" | "PAUSED";
export type WorkflowStateType = "JOB_COMPLETED" | "JOB_CREATED" | "JOB_ITEM_COUNT" | "RUN" | "TASK";
import type { FragmentReference } from "relay-runtime";
declare export opaque type UpdateJobStateModal_jobState$ref: FragmentReference;
declare export opaque type UpdateJobStateModal_jobState$fragmentType: UpdateJobStateModal_jobState$ref;
export type UpdateJobStateModal_jobState = {|
  +id: string,
  +formFieldValues: any,
  +status: JobStateStatus,
  +workflowState: {|
    +id: string,
    +name: string,
    +isAssignable: ?boolean,
    +type: ?WorkflowStateType,
    +machineType: ?{|
      +id: string
    |},
    +defaultUser: ?{|
      +id: string
    |},
    +form: ?{|
      +id: string,
      +name: string,
      +type: FormType,
      +systemKey: ?string,
      +productionType: ?{|
        +id: string
      |},
      +fields: $ReadOnlyArray<{|
        +id: string,
        +systemKey: ?string,
        +type: FormFieldType,
        +name: string,
        +description: ?string,
        +placeholder: ?string,
        +isRequired: boolean,
        +isCreatable: boolean,
        +applicationType: ApplicationType,
        +displayOrder: number,
        +properties: ?any,
        +options: $ReadOnlyArray<{|
          +name: string,
          +value: string,
          +id: string,
        |}>,
        +$fragmentRefs: AdditionalFieldInfo_formField$ref,
      |}>,
    |},
  |},
  +user: ?{|
    +id: string
  |},
  +$refType: UpdateJobStateModal_jobState$ref,
|};
export type UpdateJobStateModal_jobState$data = UpdateJobStateModal_jobState;
export type UpdateJobStateModal_jobState$key = {
  +$data?: UpdateJobStateModal_jobState$data,
  +$fragmentRefs: UpdateJobStateModal_jobState$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v3 = [
  (v0/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "UpdateJobStateModal_jobState",
  "type": "JobState",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "formFieldValues",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "workflowState",
      "storageKey": null,
      "args": null,
      "concreteType": "WorkflowState",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isAssignable",
          "args": null,
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "machineType",
          "storageKey": null,
          "args": null,
          "concreteType": "MachineType",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "defaultUser",
          "storageKey": null,
          "args": null,
          "concreteType": "User",
          "plural": false,
          "selections": (v3/*: any*/)
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "form",
          "storageKey": null,
          "args": null,
          "concreteType": "Form",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v4/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "productionType",
              "storageKey": null,
              "args": null,
              "concreteType": "ProductionType",
              "plural": false,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "fields",
              "storageKey": null,
              "args": null,
              "concreteType": "FormField",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v2/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "placeholder",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isRequired",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isCreatable",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "applicationType",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayOrder",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "properties",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "options",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "FormFieldOption",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "value",
                      "args": null,
                      "storageKey": null
                    },
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "FragmentSpread",
                  "name": "AdditionalFieldInfo_formField",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "user",
      "storageKey": null,
      "args": null,
      "concreteType": "User",
      "plural": false,
      "selections": (v3/*: any*/)
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f95b3843d1fe9f28e924dc117fff6963';
module.exports = node;
